import React from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { withLocalize } from "react-localize-redux";
import NavbarRedesignForMarketplace from "../Shared/NavbarRedesignForMarketplace";
import MainBackgroundWrapper from "../Shared/MainBackgroundWrapperForMarketplace";
import HelmetTag from "../Shared/HelmetTag";
import lightBlobsBg from "../../Assets/Images/Light_Blobs.png";
import "./styles.scss";
import SoothePassMembershipView from "./SoothePassMembershipView";
import SignupModal from "../Shared/SignupModal";
import AccessSPTab from "./AccessSPTab";

class SoothePass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.setState({ width: window.innerWidth });
    });
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };
  showRelevantView() {
    const status = get(this.props, "client.soothe_pass.state", "");
    const soothe_pass_subscription_id = get(
      this.props,
      "client.soothe_pass.soothe_pass_subscription_id",
      ""
    );
    if (!soothe_pass_subscription_id) {
      return <AccessSPTab />;
    }

    // status values: ["active", "canceled", "paused", "canceled_pending", "paused_pending"]
    switch (status) {
      case "active":
      case "paused":
      case "paused_pending":
      case "canceled_pending":
        return <SoothePassMembershipView />;
      default:
        // TODO subscription plans view here
        return <AccessSPTab />;
    }
  }

  render() {
    const loggedIn = get(this.props, "client.loggedIn", false);
    const { width } = this.state;
    const soothe_pass_subscription_id = get(
      this.props,
      "client.soothe_pass.soothe_pass_subscription_id",
      ""
    );
    if (!loggedIn) {
      return (
        <SignupModal
          isSignin
          next={() => {
            window.location.reload();
          }}
        />
      );
    }
    return (
      <>
        <HelmetTag />
        <NavbarRedesignForMarketplace notBooking showMenu />
        <MainBackgroundWrapper
          noMarginTop={this.state.width < 800}
          customImg={lightBlobsBg}
        >
          <div
            style={{
              marginLeft: width >= 1000 ? "15vw" : 0,
              padding: width >= 1000 ? "0" : "80px 0px",
              transition: "margin-left 0.2s",
              minHeight: "calc(100vh - 80px)",
            }}
          >
            <div
              className={`${
                this.state.width >= 800 ? "max-width-65 p-24" : "mb-48"
              } `}
            >
              {!soothe_pass_subscription_id ? null : (
                <div className="size-40-52 contentPrimary font-weight-bold mb-32 sm-p-24-16">
                  SoothePass™
                </div>
              )}
              {this.showRelevantView()}
            </div>
          </div>
        </MainBackgroundWrapper>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  client: state.client,
});

export default withLocalize(connect(mapStateToProps)(SoothePass));
